export default "__VITE_ASSET__CHTMYit$__"